var styles = {"defaultLabel":"Label-module_defaultLabel__NZ8FY","largeLabel":"Label-module_largeLabel__1ENmP"};

export { styles as default };
